import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('supplier/index', {params});
    },
    getSupplier(params) {
        return Service().get('supplier/get-supplier', {params});
    },
    show(id) {
        return Service().get('supplier/show/'+id);
    },
    create(params) {
        return Service().post('supplier/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('supplier/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('supplier/delete/'+id);
    },
}